// extracted by mini-css-extract-plugin
export default {"feed_show_info_box":"feed_show_info_box__08408c06"};